import * as React from 'react';
import { Assets, SortOrder } from 'components/Catalog/Interfaces/List/IListResponse';
import { useHistory, useLocation } from 'react-router';
import { parse, stringify } from 'query-string';

interface IProps {
    orders: SortOrder[];
    assets: Assets;
    orderField: string;
    orderDir: string;
    productsPerPageOptions: number[];
    currentPageSize?: number;
    onPageSizeChange: (newSize: string) => void;
}

const ORDER_DIR_ASC = 'asc';
const ORDER_DIR_DESC = 'desc';

const Toolbar = (props: IProps) => {
    const { orders, assets, orderField, orderDir, productsPerPageOptions, currentPageSize, onPageSizeChange } = props;
    const history = useHistory();
    const location = useLocation();

    // hack to move the selected field on top as data-default does not work in this context
    const sortedOrders = [...orders].sort((x, y) => {
        return x.value === orderField ? -1 : y.value === orderField ? 1 : 0;
    });

    if (!sortedOrders.length) {
        return <React.Fragment />;
    }

    const notActiveDir = orderDir === ORDER_DIR_DESC ? ORDER_DIR_ASC : ORDER_DIR_DESC;

    const getIcon = (direction: string): string => {
        return direction === ORDER_DIR_DESC ? assets.iconDown : assets.iconUp;
    };

    const pushWithQuery = (key: string, value: string) => {
        const current = parse(location.search);
        history.push({
            pathname: location.pathname,
            search: '?' + stringify({ ...current, [key]: value }),
        });
    };

    const currentMode = (parse(location.search).mode as string) || 'grid';

    return (
        <React.Fragment>
            <div className="group">
                <label>
                    {assets && <span className="label">{assets.sortLabel}</span>}
                    <select
                        value={orderField || ''}
                        onChange={(e) => pushWithQuery('product_list_order', e.target.value)}
                    >
                        {sortedOrders.map((order) => (
                            <option key={order.value} value={order.value}>
                                {order.label}
                            </option>
                        ))}
                    </select>
                    {assets && (
                        <span className="togglebutton">
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    pushWithQuery('product_list_dir', notActiveDir);
                                }}
                            >
                                <span className="icon">
                                    <img src={getIcon(notActiveDir)} alt="" />
                                </span>
                            </a>
                            <a
                                href="#"
                                className="active"
                                onClick={(e) => {
                                    e.preventDefault();
                                    pushWithQuery('product_list_dir', orderDir);
                                }}
                            >
                                <span className="icon">
                                    <img src={getIcon(orderDir)} alt="" />
                                </span>
                            </a>
                        </span>
                    )}
                </label>
            </div>
            <div className="group">
                {productsPerPageOptions.length > 0 && (
                    <label>
                        <select
                            value={currentPageSize?.toString() ?? ''}
                            onChange={(e) => onPageSizeChange(e.target.value)}
                        >
                            {productsPerPageOptions.map((size) => (
                                <option key={size} value={String(size)}>
                                    {size}
                                </option>
                            ))}
                        </select>
                    </label>
                )}
                <label>
                    {assets && <span className="label">{assets.showLabel}</span>}
                    <span className="pillbutton">
                        <a
                            href="#"
                            className={currentMode === 'grid' ? 'active' : ''}
                            onClick={(e) => {
                                e.preventDefault();
                                pushWithQuery('mode', 'grid');
                            }}
                        >
                            {assets && (
                                <span className="icon">
                                    <img src={assets.spriteGrid} alt="" />
                                </span>
                            )}
                        </a>
                        <a
                            href="#"
                            className={currentMode === 'list' ? 'active' : ''}
                            onClick={(e) => {
                                e.preventDefault();
                                pushWithQuery('mode', 'list');
                            }}
                        >
                            {assets && (
                                <span className="icon">
                                    <img src={assets.spriteList} alt="" />
                                </span>
                            )}
                        </a>
                    </span>
                </label>
            </div>
        </React.Fragment>
    );
};

export default Toolbar;
